import { ref, onMounted, onBeforeUnmount, computed, getCurrentInstance } from 'vue'
import { post, setValueByPathToVue, setValueByPath, getValueByPath } from '../../../utils/index'
import { PgDialogSelectModelServer } from '../../dialog-select-model/index'
import { clone } from '../../../utils/index'
export function useScanUdiArea({
  showScanAnalysisKeys,
  getGoodsUrl,
  scanAfter,
  onConfirm,
  getGoodsParam,
  autoEpc,
  forceConfirm,
  useAutoConfim,
  extendData,
  batchScan,
  batchTime,
  popoverVisible,
}) {
  const { proxy } = getCurrentInstance()
  const strategy = computed(() => proxy.$store?.state.strategy?.strategy ?? {})

  const udiInputRef = ref(null)
  const formRef = ref(null)
  const scanType = ref(null)
  const autoConfim = ref(false)
  const autoConfimChange = (val) => {
    localStorage.setItem('SCAN_AUTO_SUBMIT', val)
  }
  onMounted(() => {
    const autoConfimStorage = localStorage.getItem('SCAN_AUTO_SUBMIT')
    autoConfim.value = useAutoConfim ?? autoConfimStorage !== 'false'
  })
  const formData = ref({
    goodsDetail: null,
    goodsKeeping: null,
  })
  const showScanAnalysis = ref([])
  const tipText = ref('')
  const setTip = (val) => (tipText.value = val)

  const inputFocus = () => {
    setTimeout(() => udiInputRef.value.inputFocus())
  }

  const reset = () => {
    setTip('')
    formData.value = {
      goodsDetail: null,
      goodsKeeping: null,
    }
    popoverVisible.value = false
    scanType.value = ''
    showScanAnalysis.value = []
    udiInputRef.value.clearInput()
    inputFocus()
  }

  const setScanAnalysis = (resData, res) => {
    scanType.value = res.success ? res.codeType : autoEpc ? '自定义序列号码' : '普通码'
    //设置展示识别到码信息
    showScanAnalysis.value = showScanAnalysisKeys.reduce((pre, key) => {
      if (resData[key]) {
        pre.push({
          label: resData[key].label,
          value: resData[key].value,
        })
      } else if (key === 'productIdent' && resData.gtin) {
        pre.push({
          label: '产品标识',
          value: resData.gtin.value,
        })
      }
      return pre
    }, [])
  }

  const scanDisabled = ref(false)
  const scanMethod = async (resData, res, isNotAutoNext) => {
    scanDisabled.value = true
    if (
      resData.gtin ||
      resData.productIdent ||
      (!res.success && (autoEpc || !formData.value.goodsDetail?.id))
    ) {
      formData.value = {
        goodsDetail: null,
        goodsKeeping: null,
      }
      //一段码
      const goodsDetail = !forceConfirm ? await getGoods(res) : null
      formData.value.goodsDetail = goodsDetail
      // 当开启将不能识别的码自动设置为epc时将epc赋值给表单
      if (!res.success && autoEpc) {
        formData.value.epc = res.origin
      }
      inputFocus()
      if (!goodsDetail && !forceConfirm) {
        setTip('未查找到商品')
        scanDisabled.value = false
        return
      }
    } else if (!res.success) {
      setTip('系统无法识别此类信息')
      scanDisabled.value = false
      return
    }
    //二段或三段码，进行赋值
    setOtherData(resData, res)
    //执行扫码之后的钩子
    if (scanAfter) {
      formData.value =
        (await scanAfter({
          scanRes: res,
          scanForm: formData.value,
          extendData: extendData.value,
        })) ?? formData.value
    }
    udiInputRef.value.clearInput()
    //自动确认
    if (!isNotAutoNext && autoConfim.value) {
      await confirm()
    } else {
      inputFocus()
    }
    scanDisabled.value = false
  }

  const batchScanMethod = async () => {
    const batchScanData = Array.from(scanDatas.values())
    scanDatas.clear()
    // 如果是能识别的码，将一段提到最前
    if (batchScanData[0].success) {
      const oneIndex = batchScanData.findIndex((scan) => scan.data.gtin || scan.data.productIdent)
      const one = batchScanData[oneIndex]
      batchScanData.splice(oneIndex, 1)
      batchScanData.unshift(one)
      for (const scan of batchScanData) {
        await scanMethod(scan.data, scan, true)
      }
      if (autoConfim.value) {
        scanDisabled.value = true
        await confirm()
        scanDisabled.value = false
      } else {
        inputFocus()
      }
    } else if (batchScan !== 'trace' && batchScanData.length === 1) {
      return scanMethod(batchScanData[0].data, batchScanData[0])
    } else {
      const traceCodes = batchScanData.map((scan) => scan.origin)
      scanDisabled.value = true
      const [res, error] = await post(
        getGoodsUrl,
        Object.assign({ traceCodes }, getGoodsParam.value ? getGoodsParam.value : {}),
        { errorTip: '' }
      )
      if (error) {
        setTip(error.msg ?? '查找商品失败')
        inputFocus()
        scanDisabled.value = false
        return
      }
      formData.value = res.data
      //执行扫码之后的钩子
      if (scanAfter) {
        const afterRes = await scanAfter({
          scanRes: batchScanData,
          request: res,
          scanForm: formData.value,
          extendData: extendData.value,
        })?.catch((err) => err)
        inputFocus()
        if (typeof afterRes === 'string') {
          setTip(afterRes)
          scanDisabled.value = false
          return
        }
        formData.value = afterRes ?? formData.value
      }
      udiInputRef.value.clearInput()
      //自动确认
      if (autoConfim.value) {
        await confirm()
      } else {
        inputFocus()
      }
      scanDisabled.value = false
    }
  }

  // #10012 根据策略 LINK_EPC_PERIOD_SCAN 是否开启处理条码
  const setStrategyByScan = (resData, res) => {
    // 校验日期格式是否正确 (YYYY-MM-DD) 并验证日期有效性
    const isValidDateFormat = (dateStr) => {
      if (!dateStr) return false

      // 基本格式校验
      if (!/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) return false

      const parts = dateStr.split('-')
      const year = parseInt(parts[0], 10)
      const month = parseInt(parts[1], 10)
      const day = parseInt(parts[2], 10)

      // 月份范围校验
      if (month < 1 || month > 12) return false

      // 日期范围校验
      const daysInMonth = [31, isLeapYear(year) ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]
      if (day < 1 || day > daysInMonth[month - 1]) return false

      return true
    }
    // 判断是否为闰年
    const isLeapYear = (year) => {
      return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0
    }

    // 原始条码
    const origin = res.origin
    // 判断日期格式是否正确
    const hasInvalidDate =
      (resData.periodBegin && !isValidDateFormat(resData.periodBegin.value)) ||
      (resData.periodEnd && !isValidDateFormat(resData.periodEnd.value)) ||
      (resData.periodExpire && !isValidDateFormat(resData.periodExpire.value))
    // 日期格式不正确执行下面的处理
    if (hasInvalidDate) {
      resData.periodBegin = null
      resData.periodEnd = null
      resData.periodExpire = null
    }

    if (res.success) {
      if (strategy.value.LINK_EPC_PERIOD_SCAN === 'YES' && /^(11|17)/.test(origin)) {
        res.print.bracket = null
        res.print.section = null
        res.success = false
        res.codeType = ''
      }
    }
  }

  const scanDatas = new Map()
  let timer = null
  onBeforeUnmount(() => timer && clearTimeout(timer))
  const onScan = (resData, res) => {
    setTip('')
    setStrategyByScan(resData, res)
    setScanAnalysis(resData, res)
    if (!batchScan) {
      scanMethod(resData, res)
    } else {
      clearTimeout(timer)
      const scans = scanDatas.values()
      if (scans.some((scan) => scan.success !== res.success)) {
        setTip('请勿批量扫描不同类型的条码')
        scanDatas.clear()
        return
      }
      // 如果已经扫过一段码，则以后扫到的为准
      if (res.success && (resData.gtin || resData.productIdent)) {
        const repeatOne = scans.find((scan) => scan.data.gtin || scan.data.productIdent)
        if (repeatOne) {
          scanDatas.delete(repeatOne.origin)
        }
      }
      if (batchScan !== 'trace' && !res.success && scanDatas.size > 0) {
        setTip('请勿批量扫描多个唯一码')
        scanDatas.clear()
        return
      }
      scanDatas.set(res.origin, clone(res))
      timer = setTimeout(batchScanMethod, batchTime)
    }
  }

  //查找商品
  const getGoods = async (scanRes) => {
    const param = {}
    if (scanRes.data.gtin) {
      param.gtin = scanRes.data.gtin.value
    } else if (scanRes.data.productIdent && scanRes.codeType === 'MA 码') {
      param.maIdentity = scanRes.data.productIdent.value
    } else if (scanRes.data.productIdent && scanRes.codeType === 'HIBC 码') {
      param.hibcIdentity = scanRes.data.productIdent.value
    } else if (autoEpc) {
      param.epc = scanRes.origin
    } else {
      param.gtin = scanRes.origin
    }
    const [res, error] = await post(
      getGoodsUrl,
      Object.assign(param, getGoodsParam.value ? getGoodsParam.value : {}),
      { errorTip: '' }
    )
    if (error) {
      setTip(error.msg ?? '查找商品失败')
      return
    }
    if (res?.data?.length > 1) {
      return await PgDialogSelectModelServer({ data: res.data }).catch((er) => er)
    } else {
      return res?.data?.[0]
    }
  }
  //赋值其他信息
  const setOtherData = (scanData, res) => {
    const keys = Object.keys(scanData)
    for (const key of keys) {
      if (key === 'amount') {
        const goodsDetail = formData.value.goodsDetail
        // 是否开启序列号，如果开启则序列号为必填
        const ifSerial = goodsDetail?.keepingSerial
        // 数量取值判断标准
        const amountChoose = goodsDetail?.amountChoose ?? 'DEFAULT'
        // 扫到的条码上的数量
        const codeAmount = +scanData?.amount?.value || 0
        // 商品信息或扫码组件内输入的数量
        const infoAmount = +goodsDetail?.amount || 0
        // 包装规格数量
        const barcodeAmount = +goodsDetail?.barcodeAmount || 0
        // 辅助单位数量
        const unitOtherAmount = +goodsDetail?.unitOtherItem?.ratio?.dividend || 0
        // 包装规格或辅助单位数量
        const otherAmount = amountChoose === 'AUXILIARY' ? unitOtherAmount : barcodeAmount
        // 扫epc时取库存中的数量
        const storeAmount = res.success ? null : +goodsDetail?.stocking ?? null
        // 数量
        const amount =
          storeAmount !== null
            ? !forceConfirm
              ? storeAmount
              : 1
            : ifSerial
            ? 1
            : codeAmount || otherAmount || infoAmount || 1
        setValueByPathToVue(formData.value, 'amount', amount)
      } else if (key === 'batchNumber') {
        setValueByPathToVue(
          formData.value,
          'goodsKeeping.batchNumber',
          scanData.batchNumber?.value ?? getValueByPath(formData.value, 'goodsKeeping.batchNumber')
        )
      } else if (key === 'periodBegin') {
        setValueByPathToVue(
          formData.value,
          'goodsKeeping.periodBegin',
          scanData.periodBegin?.value ?? getValueByPath(formData.value, 'goodsKeeping.periodBegin')
        )
      } else if (key === 'periodEnd' || key === 'periodExpire') {
        setValueByPathToVue(
          formData.value,
          'goodsKeeping.periodEnd',
          (scanData.periodEnd?.value || scanData.periodExpire?.value) ??
            getValueByPath(formData.value, 'goodsKeeping.periodEnd')
        )
      } else if (key === 'serialNumber') {
        setValueByPathToVue(
          formData.value,
          'goodsKeeping.serialNumber',
          scanData.serialNumber?.value ??
            getValueByPath(formData.value, 'goodsKeeping.serialNumber')
        )
      }
    }
    // 记录原始条码
    setValueByPath(
      formData.value,
      'goodsKeeping.originBarCode',
      `${getValueByPath(formData.value, 'goodsKeeping.originBarCode') ?? ''}${
        res.print?.ordinary ?? ''
      }`
    )
    setValueByPath(
      formData.value,
      'goodsKeeping.originBarCodeDisplay',
      `${getValueByPath(formData.value, 'goodsKeeping.originBarCodeDisplay') ?? ''}${
        res.print?.bracket ?? ''
      }`
    )
    return formData.value
  }

  const confirm = async () => {
    if (batchScan !== 'trace' && !formData.value.goodsDetail?.id && !forceConfirm) {
      setTip('请先确认商品')
      return
    }
    const errors = await formRef.value?.validate()
    if (errors && !forceConfirm) {
      for (const errorKey of Object.keys(errors)) {
        if (errors[errorKey]?.length > 0) {
          setTip(errors[errorKey][0].message)
          inputFocus()
          return
        }
      }
    }
    if (forceConfirm) {
      if (!formData.value.amount) {
        setTip('请输入数量')
        inputFocus()
        return
      }
      if (!formData.value.epc) {
        setTip('没有扫到自定义序列号/EPC')
        inputFocus()
        return
      }
    }
    const tip = await onConfirm({ scanForm: formData.value, extendData: extendData.value })
    if (tip) {
      setTip(tip)
      inputFocus()
    } else {
      reset()
    }
  }

  return {
    udiInputRef, //扫码输入框实例
    formRef, //表单实例
    scanType, //当前码类型
    scanDisabled,
    onScan, //识别扫码内容
    autoConfim, //是否自动
    autoConfimChange, //设置缓存
    formData, //扫码表单数据
    showScanAnalysis, //显示识别到码的字段
    tipText, //错误提示内容
    setTip, //设置错误提示文字
    reset, //重置
    confirm,
  }
}
